<!-- 关联信息 -->
<template>
  <div class="relates-info-view">
    <p class="info-title">园区机构&nbsp;&nbsp;{{ zcParkList.length }}</p>

    <div class="table-box ly_table_light">
      <el-table
        :data="zcParkList"
        border
        style="width: 650px"
        header-cell-class-name="ly_table_light_header"
        cell-class-name="ly_table_light_cell"
      >
        <el-table-column
          label="园区编号"
          prop="parkId"
          align="center"
          width="264"
        >
        </el-table-column>

        <el-table-column label="园区名称" prop="parkName" align="center">
        </el-table-column>
      </el-table>
    </div>

    <p class="info-title">协会组织&nbsp;&nbsp;{{ zcAssociationList.length }}</p>

    <div class="table-box ly_table_light">
      <el-table
        :data="zcAssociationList"
        border
        style="width: 650px"
        header-cell-class-name="ly_table_light_header"
        cell-class-name="ly_table_light_cell"
      >
        <el-table-column
          label="协会组织编号"
          prop="associationId"
          align="center"
          width="264"
        >
        </el-table-column>

        <el-table-column
          label="协会组织名称"
          prop="associationName"
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>

    <p class="info-title">商会组织&nbsp;&nbsp;{{ zcCommerceList.length }}</p>

    <div class="table-box ly_table_light">
      <el-table
        :data="zcCommerceList"
        border
        style="width: 650px"
        header-cell-class-name="ly_table_light_header"
        cell-class-name="ly_table_light_cell"
      >
        <el-table-column
          label="商会组织编号"
          prop="commerceId"
          align="center"
          width="264"
        >
        </el-table-column>

        <el-table-column
          label="商会组织名称"
          prop="commerceName"
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>

    <p class="info-title">商业楼宇&nbsp;&nbsp;{{ zcPremisesList.length }}</p>

    <div class="table-box ly_table_light">
      <el-table
        :data="zcPremisesList"
        border
        style="width: 650px"
        header-cell-class-name="ly_table_light_header"
        cell-class-name="ly_table_light_cell"
      >
        <el-table-column
          label="商业楼宇编号"
          prop="premisesId"
          align="center"
          width="264"
        >
        </el-table-column>

        <el-table-column
          label="商业楼宇名称"
          prop="premisesName"
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
// api
import { getRelationInfo } from "@/api/customCompany.js";

export default {
  data() {
    //这里存放数据
    return {
      isInit: false,
      zcAssociationList: [], // 协会组织
      zcCommerceList: [], // 商会组织
      zcParkList: [], // 园区机构
      zcPremisesList: [] // 商业楼宇
    };
  },
  methods: {
    getInfo() {
      if (this.isInit) {
        return;
      }

      getRelationInfo({ id: this.$route.query.id }).then(res => {
        if (res.code == 200) {
          this.isInit = true;

          if (res.data) {
            if (Array.isArray(res.data.zcAssociationList)) {
              this.zcAssociationList = res.data.zcAssociationList;
            }

            if (Array.isArray(res.data.zcCommerceList)) {
              this.zcCommerceList = res.data.zcCommerceList;
            }

            if (Array.isArray(res.data.zcParkList)) {
              this.zcParkList = res.data.zcParkList;
            }

            if (Array.isArray(res.data.zcPremisesList)) {
              this.zcPremisesList = res.data.zcPremisesList;
            }
          }
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.relates-info-view {
  .info-title {
    margin-top: 10px;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 25px;
  }

  .table-box {
    padding-left: 190px;
    padding-bottom: 10px;
  }
}
</style>
